import React, { Component } from "react";
import moment from "moment";
moment.locale("fr", {
  months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split(
    "_"
  ),
  monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split(
    "_"
  ),
  monthsParseExact: true,
  weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
  weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
  weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd D MMMM YYYY HH:mm"
  },
  calendar: {
    sameDay: "[Aujourd’hui à] LT",
    nextDay: "[Demain à] LT",
    nextWeek: "dddd [à] LT",
    lastDay: "[Hier à] LT",
    lastWeek: "dddd [dernier à] LT",
    sameElse: "L"
  },
  relativeTime: {
    future: "dans %s",
    past: "il y a %s",
    s: "quelques secondes",
    m: "une minute",
    mm: "%d minutes",
    h: "une heure",
    hh: "%d heures",
    d: "un jour",
    dd: "%d jours",
    M: "un mois",
    MM: "%d mois",
    y: "un an",
    yy: "%d ans"
  },
  dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
  ordinal: function(number) {
    return number + (number === 1 ? "er" : "e");
  },
  meridiemParse: /PD|MD/,
  isPM: function(input) {
    return input.charAt(0) === "M";
  },
  // In case the meridiem units are not separated around 12, then implement
  // this function (look at locale/id.js for an example).
  // meridiemHour : function (hour, meridiem) {
  //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
  // },
  meridiem: function(hours, minutes, isLower) {
    return hours < 12 ? "PD" : "MD";
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
});

class Atelier extends Component {
  state = {};

  render() {
    const currentCat = this.props.categoriesId;
    const listCat = this.props.categories;
    const catAtelier = [];
    const catDesc = [];
    const catColor = [];

    for (let i = 0; i < currentCat.length; i++) {
      for (let j = 0; j < listCat.length; j++) {
        if (currentCat[i] === listCat[j].id) {
          catAtelier.push(listCat[j].name);
        }
      }
    }

    for (let i = 0; i < currentCat.length; i++) {
      for (let j = 0; j < listCat.length; j++) {
        if (currentCat[i] === listCat[j].id) {
          catDesc.push(listCat[j].description);
        }
      }
    }

    for (let i = 0; i < currentCat.length; i++) {
      for (let j = 0; j < listCat.length; j++) {
        if (currentCat[i] === listCat[j].id) {
          catColor.push(listCat[j].acf.selectionner_une_couleur);
        }
      }
    }

    let date = new moment(this.props.date, "M-D-YYYY");
    date = date.format("dddd D MMMM");
    return (
      <li className="item list-detail">
        <a
          onClick={() => this.props.showContent(this.props.atlId)}
          onMouseEnter={
            true ? () => this.props.handleMouseEnter(this.props.atlId) : null
          }
          onMouseLeave={this.props.handleMouseLeave}
          className={"lien " + catColor.map(c => c)}
          // href={this.props.url}
        >
          <div className="atelier_cat">
            <p className={"btn " + catColor.map(c => c)}>
              {catAtelier.map(a => a)}
            </p>
            <p className="cat_desc">{catDesc.map(a => a)}</p>
          </div>
          <div className={catColor.map(c => c)}>
            <p className="date">
              {date}{" "}
              <span>
                {this.props.hdebut} - {this.props.hfin}
              </span>
            </p>
            <p className="localisation">{this.props.localisation}</p>
            {this.props.complet ? (
              <p
                className="localisation"
                style={{
                  border: "1px solid white",
                  textAlign: "center",
                  padding: "5px 10px",
                  textTransform: "uppercase"
                }}
              >
                Complet
              </p>
            ) : (
              undefined
            )}
          </div>
        </a>
      </li>
    );
  }
}

export default Atelier;



// WEBPACK FOOTER //
// ./src/Components/Atelier.jsx